import { render, staticRenderFns } from "./materialSourceComponent.vue?vue&type=template&id=18fcbaf0&scoped=true&"
import script from "./materialSourceComponent.vue?vue&type=script&lang=js&"
export * from "./materialSourceComponent.vue?vue&type=script&lang=js&"
import style0 from "./materialSourceComponent.vue?vue&type=style&index=0&id=18fcbaf0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fcbaf0",
  null
  
)

export default component.exports